var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-top-sm"},[_c('a',{staticClass:"conversation--link",style:(`background-color: rgba(${_vm.settings.bgColorRGBA}); color: rgba(${_vm.settings.fontColorRGBA});`),attrs:{"href":_vm.link.href,"target":"_system"}},[_vm._v("\n    "+_vm._s(_vm.link.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }